import { Icon } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { type ComponentPropsWithRef } from 'react';

import './account-button.scss';

export function AccountButton({ className, ...props }: ComponentPropsWithRef<'button'>) {
    return (
        <button {...props} type="button" className={cn('account-button', className)} aria-label="Account menu">
            <Icon name="account-circle-outline" size="lg" aria-hidden="true" />
        </button>
    );
}
